/* global google */
import React from 'react';
import MapStyles from './Styles/index';

class Map extends React.Component {
  constructor(props) {
    super(...arguments);

    this.state = {
      mode: props.section.get('properties').map_props.type,
      address: encodeURIComponent(
        props.section.get('properties').map_props.location
      ),
      destination: encodeURIComponent(
        props.section.get('properties').map_props.destination
      ),
      loaded: FW.inEditor()
    };
  }

  componentDidMount(){
    const startMap = () => {
      setTimeout(() => {
        $('#PageSection_' + this.props.section.get('id')).appear(() => {
          if (!FW.inEditor()) {
            this.setState({
              loaded: true
            });
          }
        });
      }, 500);
    };
    if (document.readyState === "complete") {
      startMap();
    } else {
      window.addEventListener('load', startMap);
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.setState({
        mode: props.section.get('properties').map_props.type,
        address: encodeURIComponent(
          props.section.get('properties').map_props.location
        ),
        destination: encodeURIComponent(
          props.section.get('properties').map_props.destination
        )
      });
    }, 2000);
  }

  render() {
    let section = this.props.section;
    let height = section.get('properties').map_props.height || 300;
    let style = {
      margin: '0 auto',
      width: '100%',
      height: height,
      textAlign: 'center'
    };
    let mapId = 'map_' + section.get('id');

    let qs;
    if (this.state.mode === 'directions') {
      qs =
        '&origin=' +
        this.state.address +
        '&destination=' +
        this.state.destination;
    } else {
      qs = '&q=' + this.state.address;
    }

    let src =
      'https://www.google.com/maps/embed/v1/' +
      this.state.mode +
      '?key=' +
      FW.store.get('gmap_key') +
      qs;
    if (section.get('properties').map_props.zoom) {
      src += '&zoom=' + section.get('properties').map_props.zoom;
    }

    return (
      <div style={style} className="google-map">
        {this.state.loaded ? <iframe
          id={mapId}
          style={{
            width: '100%',
            height: '100%',
            minHeight: 'inherit',
            border: 0
          }}
          src={src}
          aria-label="Google Map"
        /> : null}
      </div>
    );
  }
}

export default Map;
